import Image from '@/components/UI/Image';
import { f } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
export default function Delta2Group1() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstationevent');
    const [expandFont, setExpandFont] = useState(false);
    const [isShowMask, isSetShowMask] = useState(false);
    const [isShowFont, isSetShowFont] = useState(false);
    let bigFont = false;

    // 多语言换行需要增加动画滚动距离， 每行0.36rem
    const aniDistance: any = {
        de: '-143vh',
        fr: '-143vh',
        it: '-143vh',
        es: '-136vh',
    };
    useEffect(() => {
        const maskBottomDom: any = document.querySelector('.mask-bottom img');
        const intervalId = setInterval(() => {
            if (maskBottomDom?.complete) {
                clearInterval(intervalId);
                isSetShowMask(true);
                setTimeout(() => {
                    isSetShowFont(true);
                });
            }
        }, 200);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.delta2_p1`,
            offset: 65, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const timelineA1 = new TimelineMax();

        const tween1 = TweenMax.fromTo(
            '.delta2_p1 .font-ani-box',
            1,
            {
                y: 0,
            },
            {
                y: aniDistance[locale] || '-121vh',
            },
        );

        timelineA1.add(tween1);

        sceneA1.on('progress', (self: any) => {
            const progress = self.progress;
            if (progress > 0.9 && !bigFont) {
                setExpandFont(true);
                bigFont = true;
            } else if (bigFont && progress <= 0.9) {
                setExpandFont(false);
                bigFont = false;
            }
        });

        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.delta2_p1} delta2_p1`}>
            <div className="sticky-box">
                <div className="bg-img">
                    <Image src="/img/delta2Activilypage/first_page_bg_PC.jpg" layout="fill" className="fullImgs" alt="bg"></Image>
                </div>
                <div className="delta2-img">
                    <Image src="/img/delta2Activilypage/first_page_delta_PC.png" layout="fill" className="fullImgs" alt="Delta2"></Image>
                </div>
                <div className={`mask-top ${isShowMask ? 'show-mask' : ''}`}>
                    <div>
                        <img
                            alt="Delta2"
                            decoding="async"
                            data-nimg="fill"
                            src={f('/img/delta2Activilypage/first_page_mask_top_PC.png')}
                            className="fullImgs"
                        />
                    </div>
                </div>
                <div className={`mask-bottom ${isShowMask ? 'show-mask' : ''}`}>
                    <div>
                        <img
                            alt="Delta2"
                            decoding="async"
                            data-nimg="fill"
                            src={f('/img/delta2Activilypage/first_page_mask_bottom_PC.png')}
                            className="fullImgs"
                        />
                    </div>
                </div>
                <div className="ani-box">
                    <div className={`font-ani-box ${isShowFont ? 'show-font' : ''}`}>
                        <div className="msg-line title1">{t('group1-title1')}</div>
                        <div className="msg-line title2">{t('group1-title2')}</div>
                        <div className="msg-line title3">{t('group1-title3')}</div>
                        <div className="msg-line title4">{t('group1-title4')}</div>
                        <div className="msg-line title5">{t('group1-title5')}</div>
                        <div className="msg-line title6">{t('group1-title6')}</div>
                        <div className="msg-line title7">{t('group1-title7')}</div>
                        <div className="msg-line title8">{t('group1-title8')}</div>
                        <div className={`msg-line title9 ${expandFont ? 'expand-font' : ''}`}>{t('group1-title9')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
